import { render, staticRenderFns } from "./IconPeople.vue?vue&type=template&id=9f209722&scoped=true"
import script from "./IconPeople.vue?vue&type=script&lang=js"
export * from "./IconPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f209722",
  null
  
)

export default component.exports